<mat-card class="content-card">
  <mat-card-header class="loading-header" [ngClass]="{ loading: isLoading$ | async }">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading$ | async"></mat-progress-bar>
  </mat-card-header>
  <form [formGroup]="form" class="messages-form" (submit)="getMessages()">
    <!-- Organisations -->
    <mat-form-field appearance="outline">
      <mat-label>Organisation</mat-label>
      <mat-select formControlName="organisation">
        <mat-option *ngIf="isLoading$ | async" [value]=""> Loading... </mat-option>
        <mat-option *ngFor="let org of organisations" [value]="org">
          {{ org }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!-- Card Action Types -->
    <mat-form-field appearance="outline">
      <mat-label>Connector action type</mat-label>
      <mat-select formControlName="actionTypes" multiple>
        <mat-option
          *ngFor="let action of connectorActionTypes"
          [value]="action"
        >
          {{ action }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!-- Card Status Types -->
    <mat-form-field appearance="outline">
      <mat-label>Message status</mat-label>
      <mat-select formControlName="statusTypes" multiple>
        <mat-option *ngFor="let status of messageStatusTypes" [value]="status">
          {{ status }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!-- User Id -->
    <mat-form-field appearance="outline">
        <mat-label>User Id</mat-label>
        <input matInput formControlName="userId" />
    </mat-form-field>
    <!-- Date Start & Date End -->
    <mat-form-field appearance="outline">
      <mat-label>Date Range (Max 7 days)</mat-label>
      <mat-date-range-input [rangePicker]="picker" [max]="maxDate">
        <input
          matStartDate
          formControlName="dateStart"
          placeholder="Start Date"
        />
        <input matEndDate formControlName="dateEnd" placeholder="End Date" />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <button mat-raised-button color="primary" type="submit">
      Get messages
    </button>
  </form>
  <mat-form-field class="filter" appearance="standard">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" #input />
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>
  <mat-table mat-table [dataSource]="results" matSort class="mat-elevation-z0">
    <ng-container matColumnDef="organisation">
      <mat-header-cell
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Sort by organisation"
        >Organisation</mat-header-cell
      >
      <mat-cell mat-cell *matCellDef="let element">{{
        element.organisation
      }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="connector">
      <mat-header-cell
        mat-header-cell
        *matHeaderCellDef
        sortActionDescription="Sort by connectors"
        >Connector</mat-header-cell
      >
      <mat-cell mat-cell *matCellDef="let element">{{
        element.connectors.join(', ')
      }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="action">
      <mat-header-cell
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Sort by card action"
        >Action</mat-header-cell
      >
      <mat-cell mat-cell *matCellDef="let element">{{
        element.action
      }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Sort by card status"
        >Status</mat-header-cell
      >
      <mat-cell mat-cell *matCellDef="let element"><span [class]='element.status'>
        <span *ngIf="isRetryMessage(element.queueMessage)">Retry</span> {{
        element.status
      }}</span></mat-cell>
    </ng-container>

    <ng-container matColumnDef="errors">
      <mat-header-cell
        mat-header-cell
        *matHeaderCellDef
        sortActionDescription="Sort by errors"
        >Errors</mat-header-cell
      >
      <mat-cell mat-cell *matCellDef="let element">
        <span class="error" *ngIf="element.errorList.length > 0 && !isRetryMessage(element.queueMessage)">
          <i class="fas fa-exclamation"></i>
        </span>
        <span class='retry-error' *ngIf="element.errorList.length > 0 && isRetryMessage(element.queueMessage)">
            <i class="fa fa-asterisk fa-1x"></i>
        </span>
        <span class='retry-error' *ngIf="element.errorList.length > 0">
            {{handleErrors(element.errorList)}}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="userId">
        <mat-header-cell
          mat-header-cell
          *matHeaderCellDef
          sortActionDescription="Sort by userId"
          >User Id</mat-header-cell
        >
        <mat-cell mat-cell *matCellDef="let element"><span [class]='element.status'>{{
            getUserId(element.queueMessage)
          }}</span></mat-cell>

    </ng-container>

    <ng-container matColumnDef="processDate">
      <mat-header-cell
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Sort by process date"
        >Process date</mat-header-cell
      >
      <mat-cell mat-cell *matCellDef="let element">{{
        element.processDate | date: 'short'
      }}</mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      matRipple
      *matRowDef="let row; columns: displayedColumns"
      (click)="viewDetail(row)"
    ></mat-row>
    <div class="no-data" *matNoDataRow>
      <span mat-cell *ngIf="results.data.length === 0">No data returned</span>
      <span mat-cell *ngIf="results.data.length > 0"
        >No data matching "{{ input.value }}" filter</span
      >
    </div>
  </mat-table>
  <mat-paginator
    [pageSizeOptions]="[10, 20, 50, 100, 200]"
    showFirstLastButtons
    class="mat-elevation-z0"
  ></mat-paginator>
  <span class='retry-error'>
    <i class="fa fa-asterisk fa-1x"></i>
    Retry message (ttl < {{retryTtl}})
</span>
</mat-card>
